var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",attrs:{"data-active":_vm.active}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader__wrap"},[_c('div',{staticClass:"loader__loader"})])
}]

export { render, staticRenderFns }